import { applicationSessionStorage } from '@application/application_storage_session';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { BookingScreen, useBooking } from './use_booking';
import { type BasketStorageData, useBookingBasket } from './use_booking_basket';

export function useBookingRouteSetup() {
	const viewBooking = useBooking();
	const bookingBasket = useBookingBasket();
	const [searchParams] = useSearchParams();

	useEffect(() => {
		const basketStorageData: Partial<BasketStorageData> = {};

		const rescheduleTicket = searchParams.get('rescheduleTicket');
		if (rescheduleTicket) {
			basketStorageData.rescheduleTicket = rescheduleTicket;
		}

		// Do not keep reschedulingReason in URL since it is more sensitive, can be caught in analytics or logs
		const reschedulingReason = applicationSessionStorage.get('reschedulingReason');
		if (reschedulingReason !== null) {
			basketStorageData.reschedulingReason = reschedulingReason;
			applicationSessionStorage.removeItem('reschedulingReason');
		}

		if (basketStorageData.rescheduleTicket || basketStorageData.reschedulingReason) {
			bookingBasket.setBasket(basketStorageData);
		}

		(async () => {
			const restoreResult = await bookingBasket.restoreBasket();
			if (restoreResult.err) {
				bookingBasket.clearBasket();
				viewBooking.goToScreen(BookingScreen.WhoIsRespondant, { replace: true });
				return;
			}
		})();
		viewBooking.loadSettings();
	}, [
		bookingBasket.setBasket,
		bookingBasket.restoreBasket,
		bookingBasket.clearBasket,
		searchParams,
		viewBooking.goToScreen,
		viewBooking.loadSettings,
	]);
}
